export const utm = (link, sep = '&') => {
    if (!link) return {};
    let qs = '';
    try {
        const url = new URL(decodeURIComponent(link));
        qs = url.search || '';
    } catch {
        const idx = link.indexOf('?');
        qs = idx >= 0 ? link.slice(idx) : link;
    }
    if (qs.startsWith('?')) qs = qs.slice(1);
    qs = qs.split('#')[0];

    if (sep !== '&') {
        return qs.split(sep).reduce((acc, pair) => {
            if (!pair) return acc;
            const [rawK, rawV = ''] = pair.split('=');
            const k = rawK;
            if (/^utm_/i.test(k)) acc[k] = decodeURIComponent(rawV.replace(/\+/g, ' '));
            return acc;
        }, {});
    }

    const params = new URLSearchParams(qs);
    const out = {};
    for (const [k, v] of params) {
        if (k.toLowerCase().startsWith('utm_')) out[k] = v.replace(/\+/g, ' ');
    }
    return out;
};
